import React from "react";
import { FloorPlanScopeProvider } from "./context/FloorPlanScopeContext";
import FloorPlanEditor from "./components/floorPlan/FloorPlanEditor";
import "./floorplan.css";

export default function Floormap() {
  return (
    <div className="inc-floorplan">
      <FloorPlanScopeProvider>
        <div className="vvdn-app-main">
          <FloorPlanEditor />
        </div>
      </FloorPlanScopeProvider>
    </div>
  );
}
